<!-- <template>
	<el-submenu v-if="menu.children.length>=1" :index="menu.code"  >
		<template slot="title" >
			<i class="el-icon-folder" style="font-size: 14px; color: black" ></i>
			<span slot="title" style="font-size: 14px;margin-left: -6px;"><span style="color: black">{{menu.text}}</span></span>
		</template>
		<SideMenuItem v-for="item in menu.children" :key="item.id" :menu="item" style="margin-left: -11px;"></SideMenuItem>
	</el-submenu>
	<el-menu-item v-else-if="menu.state==='0'" :index="menu.url" >
		<template slot="title">
			<i class="el-icon-folder-opened" style="font-size: 14px; color: #000000;margin-left: 0px;" ></i>
			<span slot="title" style="font-size: 14px;margin-left: -8px;"><span style="color: black">{{menu.text}}</span></span>
		</template>
	</el-menu-item>
</template> -->

<template>
  <el-submenu v-if="menu.children.length>=1" :index="menu.code">
    <template slot="title">
      <i class="el-icon-folder"></i>
      <span slot="title">{{menu.text}}</span>
    </template>
    <SideMenuItem v-for="item in menu.children" :key="item.id" :menu="item"></SideMenuItem>
  </el-submenu>
  <el-menu-item v-else-if="menu.state==='0'" :index="menu.url">

    <i class="el-icon-folder-opened"></i>
    <span slot="title">{{menu.text}}</span>

  </el-menu-item>
</template>


<script>
  export default {
    name: 'SideMenuItem',
    data() {
      return {
        changeColor: '#e5fff3',
      }
    },
    props: {
      menu: {
        type: Object,
        required: true
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/view/framework/home/SideMenuItem.vue